import { motion } from "framer-motion";

const JellyButton = ({ children, variant = "primary", className = "", disabled = false, ...props }) => {
  const baseClasses = variant === "primary" ? "btn-jelly-primary" : "btn-jelly-secondary";
  
  // Disabled state styling
  const disabledClasses = disabled 
    ? "opacity-50 cursor-not-allowed pointer-events-none" 
    : "";
  
  return (
    <motion.button
      whileHover={disabled ? {} : { scale: 1.02 }}
      whileTap={disabled ? {} : { scale: 0.98 }}
      className={`${baseClasses} ${disabledClasses} ${className} flex items-center justify-center gap-2 font-bold`}
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default JellyButton;
